import { Component, Input } from '@angular/core';

@Component({
  selector: 'error',
  template: `
  <div class="table-responsive" *ngIf="error != null && error.errorList != null">
    <table class="table table-bordered table-hover table-striped">
      <thead>
        <tr>
          <th>Code</th>
          <th>Description</th>
          <th>Link</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of error.errorList; let i = index">
          <td>{{item.code}}</td>
          <td>{{item.description}}</td>
          <td>
            <a href="{{item.url}}" target="_blank">More details</a>
          </td>
        </tr>
      </tbody>
      <tfoot>
      </tfoot>
    </table>
  </div>`
})
export class ErrorComponent {
  @Input() error: any = null;
  constructor() {
  }
 }
